// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.link-form {
    display: flex;
    padding: 10px 0;
}
.link-form input {
    flex-grow: 1;
    padding: 5px;
    font-size: 16px;
    margin-right: 5px;
}

@media (1600px <= width) {
    .link-form .button-text {
        display: inline-block;
    }
    .link-form .button svg {
        display: none;
    }
}

@media (700px < width < 1600px) {
    .link-form .button-text {
        display: inline-block;
    }
    .link-form .button svg {
        display: none;
    }
}
@media (width <= 700px) {
    .link-form .button-text {
        display: none;
    }
    .link-form .button svg {
        display: inline-block;
    }
}
`, "",{"version":3,"sources":["webpack://./client/components/posts/PostForm/LinkForm/LinkForm.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;AACnB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,qBAAqB;IACzB;IACA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,qBAAqB;IACzB;IACA;QACI,aAAa;IACjB;AACJ;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,qBAAqB;IACzB;AACJ","sourcesContent":[".link-form {\n    display: flex;\n    padding: 10px 0;\n}\n.link-form input {\n    flex-grow: 1;\n    padding: 5px;\n    font-size: 16px;\n    margin-right: 5px;\n}\n\n@media (1600px <= width) {\n    .link-form .button-text {\n        display: inline-block;\n    }\n    .link-form .button svg {\n        display: none;\n    }\n}\n\n@media (700px < width < 1600px) {\n    .link-form .button-text {\n        display: inline-block;\n    }\n    .link-form .button svg {\n        display: none;\n    }\n}\n@media (width <= 700px) {\n    .link-form .button-text {\n        display: none;\n    }\n    .link-form .button svg {\n        display: inline-block;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
